/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTQuMTY2OEwxMC44MzMzIDEwLjAwMDJMMTUgNS44MzM1TTkuMTY2NjcgMTQuMTY2OEw1IDEwLjAwMDJMOS4xNjY2NyA1LjgzMzUiIHN0cm9rZT0iIzE4MUQyNyIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";